module.exports = __webpack_public_path__ + "static/study_guide-1d2d848b8d72bb89009dcbf737c0917b.pdf";